import React from "react";
import { Col, Image, Row } from "react-bootstrap";
import { isPermited } from "../../../features/localStorage";
import EditEthicsTeamContactDetails from "../../help/admin/EditEthicsTeamContactDetails";
import { useAppSelector } from "../../../app/hooks";
import { selectContacts } from "../../../features/helpandassistance/contactsSlice";
import Image1 from "../../../assets/images/speakup.jpg";
import Image2 from "../../../assets/images/call.svg";
import Image3 from "../../../assets/images/raisecomplaint.svg";
import Image4 from "../../../assets/images/how_raise_com.svg";
import Image5 from "../../../assets/images/report.svg";

const EthicsConcerns = () => {
  const ContactsReducer = useAppSelector(selectContacts);
  return (
    <>
      <Row
        style={{
          padding: '16px 20px',
          paddingBottom: '4px'
        }}
      >
        <Col sm={6} style={{ paddingLeft: 0, paddingTop: 5 }}>
          <div
            style={{
              fontSize: '17px',
              fontWeight: 'bold',
              fontStretch: 'normal'
            }}
          >
            <h4>Ethics Helpline</h4>
          </div>
        </Col>
        {isPermited(8, 3) && (
          <Col className='desk' sm={6}>
            <span style={{ float: 'right' }}>
              <EditEthicsTeamContactDetails
                contact={ContactsReducer}
                label=''
                isForEdit={true}
                isListShow={false}
              />
            </span>
          </Col>
        )}
      </Row>
      <Row style={{ padding: '10px', paddingTop: '0px' }}>
        <Col xs={4} style={styles.col}>
          <div style={styles.divGray} className='p-0'>
            <Image src={Image1} style={{ width: '100%' }} />
          </div>
        </Col>
        <Col xs={4} style={styles.col}>
          <div style={styles.divGray}>
            <div style={styles.img}>
              <Image src={Image2} style={{ width: '40px' }} />
            </div>
            <div style={styles.title}>
              Call <b style={{ color: '#000' }}>24/7</b> secure | Ethics
              Helpline
              <br />
              <b style={{ fontWeight: 'bolder', fontSize: 14 }}>
                000-800-100-4175
              </b>
            </div>
            <div style={styles.content}>
              Administered by a global and an independent service provider.
            </div>
          </div>
        </Col>
        <Col xs={4} style={styles.col}>
          <div style={styles.divGray}>
            <div style={styles.img}>
              <Image src={Image3} style={{ width: '40px' }} />
            </div>
            <div style={styles.title}>
              <h4 style={{ color: '#000' }}>Who can raise a complaint?</h4>
            </div>
            <div style={styles.content}>
              All stakeholders: employees, distributors, dealers, suppliers,
              vendors and customers, etc. to report any code violation or any
              ethics related concern.
            </div>
          </div>
        </Col>
        <Col xs={8} style={styles.col}>
          <div style={styles.divGray}>
            <div style={styles.img}>
              <Image src={Image4} style={{ width: '40px' }} />
            </div>
            <div style={styles.title}>
              <h4 style={{ color: '#000' }}>How to raise a complaint?</h4>
            </div>
            <ul>
              <li>
                <div style={styles.subTitle}>
                  Call on{' '}
                  <b style={{ fontWeight: 'bolder', fontSize: 14 }}>
                    000-800-100-4175
                  </b>
                  &nbsp; and a representative will register the complaint
                  through the web portal.
                </div>
              </li>
              <li>
                <div style={styles.content}>
                  <span style={styles.subTitle}>Visit: </span>
                  <a
                    href='http://ethics.mahindra.com'
                    rel='noopener noreferrer'
                    target='_blank'
                  >
                    <b style={{ fontSize: 14 }}>ethics.mahindra.com</b>
                  </a>{' '}
                  to register a complaint and attach relevant evidence.
                </div>
              </li>
              <li>
                <div style={styles.content}>
                  <span style={styles.subTitle}>
                    Available in local and foreign languages.{' '}
                  </span>
                </div>
              </li>
            </ul>
          </div>
        </Col>
        <Col xs={4} style={styles.col}>
          <div style={styles.divGray}>
            <div style={styles.img}>
              <Image src={Image5} style={{ width: '40px' }} />
            </div>
            <div style={styles.title}>
              <h4 style={{ color: '#000' }}>
                What happens to a complaint once it is raised?
              </h4>
            </div>
            <div style={styles.subTitle}>For details, click</div>
            <div style={styles.content}>
              <a
                style={styles.content}
                href='https://ethics.mahindra.com/chart'
                rel='noopener noreferrer'
                target='_blank'
              >
                <b style={{ fontSize: 14 }}>
                  https://ethics.mahindra.com/chart
                </b>
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default EthicsConcerns;

const styles = {
  col: {
    padding: "10px",
    marginTop: "8px",
  },
  divGray: {
    backgroundColor: "#e4e4e4",
    marginTop: "0px",
    // minHeight: "190px",
    padding: "10px",
    height: "100%",
  },
  img: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    // backgroundColor: '#e31837',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "-30px",
    marginBottom: "10px",
    // border: 'solid 2px #fff',
  },
  title: {
    fontSize: "14px",
    fontWeight: 700,
    marginBottom: "6px",
  },
  subTitle: {
    fontSize: "14px",
    fontWeight: 600,
    lineHeight: "16px",
  },
  content: {
    fontSize: "14px",
    fontWeight: 500,
    color: "#000",
    lineHeight: "16px",
  },
};
